export const CHATGPT_GUIDE = `Create a complete, self-contained educational simulation as ONE HTML file.

Requirements:
- Start with <!doctype html> and end with </html>. Put all CSS in <style> and all JS in <script>.
- The scene must fill 100% of the window (html, body { margin:0; height:100%; overflow:hidden }) and scale
  responsively WITHOUT cropping (SVG with viewBox + preserveAspectRatio="xMidYMid meet", or a canvas that resizes on window resize).
- Design for a 16:9 frame. Support mouse AND touch (use pointer events). Big, clear, beginner-friendly controls. Arabic labels.
- No timers/countdowns. No forms, no popups, no alerts, no network requests, no localStorage.
- External libraries ONLY from: https://cdn.jsdelivr.net, https://unpkg.com, https://cdnjs.cloudflare.com, https://esm.sh
  (e.g. Three.js via https://cdn.jsdelivr.net/npm/three@0.160.0/build/three.module.js). Images only as inline SVG or data: URLs.

Integration with the AutoMeetNetwork website (very important):
The website injects an object window.AMN before your script runs. Always guard it:
  const AMN = window.AMN || { on(){}, ready(){}, metrics(){}, state(){}, result(){} };

Register command handlers (call only those you support):
  AMN.on('start', () => {...})            // start / run the scene
  AMN.on('stop', () => {...})             // stop the scene
  AMN.on('reset', () => {...})            // back to the initial state
  AMN.on('goto', ({ step }) => {...})     // jump to a named situation/step
  AMN.on('showAnswer', ({ questionId, step }) => {...})  // play the explanatory animation for that step
  AMN.on('answer', ({ questionId, choice, correct, step }) => {...})  // optional: react to the learner's choice

Report to the website:
  AMN.ready({ supports: ['start','stop','reset','goto','showAnswer'] })   // call once when the scene is ready
  AMN.metrics([{ label: 'حالة المحرك', value: 'يعمل', tone: 'green' }])   // up to 6 status boxes; tone: green|red|blue|amber|gray
  AMN.state({ ... })   // optional current state
  AMN.result({ event: 'motor_started' })  // optional events

List the step names you implemented (e.g. 'start-sequence', 'stop-sequence') at the end of your answer,
so I can link each question to a step. The simulation must also work normally if window.AMN is missing.

Simulation topic: <describe the simulation here>`;
